import { withRecommendationProvider } from 'libs/athos/components/recommendations/withRecommendationsProvider'
import { CarouselResults } from 'libs/athos/components/recommendations/CarouselResults'
import { GridResults } from 'libs/athos/components/recommendations/GridResults'

export const observedAttributes = ['profile', 'item-class', 'product-id', 'carousel-settings', 'product-card-settings', 'limit', 'values', 'card']

export const CarouselCollection = withRecommendationProvider(CarouselResults, 'collection')
export const CarouselRecommend = withRecommendationProvider(CarouselResults, 'recommend')
export const GridCollection = withRecommendationProvider(GridResults, 'collection')
export const GridRecommend = withRecommendationProvider(GridResults, 'recommend')
